const getColorAtIndex = function(index) {
  let colors = ["#57cc99", "#38a3a5", "#80ed99", "#c7f9cc", "#22577a"];

  return colors[index % colors.length];
};

export default getColorAtIndex;
